import { BreadcrumbModel } from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Params, RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { FileHashPipe } from '../../pipes/file-hash.pipe';
import { ClipboardService } from '../../services/clipboard.service';
import { CopyButton } from '../copy-button/copy-button.component';
import { EntityBadge } from '../entity-badge/entity-badge.component';

export enum TestIds {
  Breadcrumbs = 'Breadcrumbs',
}

@Component({
  selector: 'procure-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  imports: [
    RouterLink,
    EntityBadge,
    MatIcon,
    MatTooltip,
    QuicklinkDirective,
    CopyButton,
    FileHashPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Breadcrumbs {
  readonly breadcrumbs = input.required<BreadcrumbModel[] | null>();
  readonly externalLink = input<string | null>();
  readonly sapAribaLink = input<string | null>();
  readonly orbisLink = input<string | null>();
  readonly sncrpLink = input<string | null>();
  readonly gravityLink = input<string | null>();
  readonly xapienLink = input<string | null>();
  readonly ecoVadisLink = input<string | null>();

  readonly entityClickable = input<boolean, BooleanInput>(true, {
    transform: booleanAttribute,
  });

  protected readonly TestIds = TestIds;

  private readonly clipboardService = inject(ClipboardService);

  protected copyName(breadcrumb: BreadcrumbModel): void {
    if (!breadcrumb.displayName) {
      return;
    }

    this.clipboardService.copy(breadcrumb.displayName);
  }

  protected copyLink(breadcrumb: BreadcrumbModel): void {
    this.clipboardService.copy(
      breadcrumb.url
        ? `${window.location.origin}${breadcrumb.url}`
        : window.location.href,
    );
  }

  protected splitUrl(url: string): string[] {
    const result = url.split('?')[0].split('/');
    result[0] = '/';
    return result;
  }

  protected queryParams(url: string): Params | null {
    const query = url.split('?')[1];

    return query ? Object.fromEntries(new URLSearchParams(query)) : null;
  }
}
